/*
  tos-datalayer.js — UX-Events fuer den GTM-Container GTM-WZ9DF5NK.

  Zweck: Die Shopify-Web-Pixel (Google, Meta, TikTok, Klaviyo) messen bereits den
  kompletten Ecommerce-Trichter bis zum Kauf. Was KEIN App-Pixel sieht, ist das
  Verhalten davor: ENTER-Portal, Fit-Quiz, Groessentabelle, Wishlist, Popups.
  Genau diese Events landen hier im dataLayer und werden von GTM als eigene
  GA4-Events weitergereicht. Bewusst NICHTS, was ein Pixel schon feuert
  (kein page_view, kein add_to_cart, kein purchase) — sonst Doppelzaehlung.

  Consent: gepusht wird nur bei Statistik-Einwilligung (window.TOSConsent aus
  snippets/consent-gate.liquid). Ohne Einwilligung laedt GTM ohnehin nicht,
  aber so liegen auch keine Verhaltensdaten im dataLayer herum.

  Selektoren stammen aus dem echten Theme-Code:
    .home-hero__cta            sections/home-portal.liquid
    .open-fit-quiz             assets/fit-quiz.js
    [data-fq-result]           Ergebnisblock des Quiz
    [aria-controls^=SizeChartModal-]  snippets/product-variant-picker.liquid
    [data-wishlist-handle]     assets/wishlist-v2.js (aria-pressed = geherzt)
    .tos-timed[data-timed-popup] / .tos-exit[data-exit-intent]  (.is-open)
    [data-advertorial-cta]     sections/advertorial-article.liquid (CTA-Blocks)
*/
(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  function allowed() {
    return !!(window.TOSConsent && window.TOSConsent.get('analytics'));
  }

  function push(name, params) {
    if (!allowed()) return;
    var payload = { event: name };
    if (params) {
      for (var k in params) {
        if (Object.prototype.hasOwnProperty.call(params, k)) {
          var v = params[k];
          if (v !== undefined && v !== null && v !== '') payload[k] = v;
        }
      }
    }
    try { window.dataLayer.push(payload); } catch (e) {}
  }

  /* Produkt-Handle: erst aus dem Markup, sonst aus der URL (PDP). */
  function handleFor(el) {
    var n = el && el.closest
      ? el.closest('[data-fq-product-handle],[data-product-handle],[data-wishlist-handle]')
      : null;
    if (n) {
      var h = n.getAttribute('data-fq-product-handle')
           || n.getAttribute('data-product-handle')
           || n.getAttribute('data-wishlist-handle');
      if (h) return h;
    }
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function text(el) {
    var t = (el && el.textContent) ? el.textContent.replace(/\s+/g, ' ').trim() : '';
    return t.slice(0, 100);
  }

  /* ── Klick-Events, delegiert (ueberlebt innerHTML-Austausch, z.B. Quick-View) ── */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var enter = t.closest('.home-hero__cta');
    if (enter) {
      push('tos_enter_portal', {
        cta_text: text(enter),
        cta_url: enter.getAttribute('href') || ''
      });
      return;
    }

    var quiz = t.closest('.open-fit-quiz');
    if (quiz) {
      push('tos_quiz_open', { product_handle: handleFor(quiz) });
      return;
    }

    /* Groessentabelle: Trigger, nicht das Overlay (das schliesst nur). */
    var sc = t.closest('[aria-controls^="SizeChartModal-"]');
    if (sc && !sc.classList.contains('fixed-overlay')) {
      push('tos_size_chart_open', { product_handle: handleFor(sc) });
      return;
    }

    var heart = t.closest('[data-wishlist-handle]');
    if (heart) {
      var h = handleFor(heart);
      /* Zustand erst NACH dem Theme-Handler lesen: ausgeloggt oeffnet
         wishlist-v2.js das Login-Gate (WishlistLoginModal), statt zu speichern. */
      window.setTimeout(function () {
        var gate = document.getElementById('WishlistLoginModal');
        if (gate && gate.classList.contains('is-open')) {
          push('tos_wishlist_login_gate', { product_handle: h });
          return;
        }
        var added = heart.getAttribute('aria-pressed') === 'true';
        push(added ? 'tos_wishlist_add' : 'tos_wishlist_remove', { product_handle: h });
      }, 400);
      return;
    }

    var adv = t.closest('[data-advertorial-cta]');
    if (adv) {
      push('tos_advertorial_cta_click', {
        cta_position: adv.getAttribute('data-advertorial-cta') || '',
        cta_text: text(adv),
        cta_url: adv.getAttribute('href') || '',
        page_path: window.location.pathname
      });
      return;
    }

    if (t.closest('[data-timed-close]')) { push('tos_popup_dismissed', { popup_type: 'timed' }); return; }
    if (t.closest('[data-exit-close]')) {
      var ex = document.querySelector('.tos-exit[data-exit-intent]');
      push('tos_popup_dismissed', {
        popup_type: 'exit_intent',
        popup_variant: ex ? (ex.getAttribute('data-variant') || '') : ''
      });
    }
  }, true);

  /* ── Quiz-Ergebnis: [data-fq-result] wechselt von hidden auf sichtbar ── */
  function watchQuizResult() {
    if (!window.MutationObserver) return;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var el = muts[i].target;
        if (!el.getAttribute || el.getAttribute('data-fq-result') === null) continue;
        if (el.hidden) continue;
        if (el.dataset.tosDlFired === '1') continue;
        el.dataset.tosDlFired = '1';
        var modal = el.closest('[data-fq-product-handle]');
        var cta = modal ? modal.querySelector('[data-fq-rec-size]') : null;
        push('tos_quiz_result', {
          product_handle: modal ? modal.getAttribute('data-fq-product-handle') : handleFor(el),
          recommended_size: cta ? (cta.getAttribute('data-fq-rec-size') || '') : ''
        });
      }
    }).observe(document.documentElement, {
      subtree: true, attributes: true, attributeFilter: ['hidden']
    });
  }

  /* ── Popups: Root bekommt .is-open ── */
  function watchPopup(selector, type) {
    var root = document.querySelector(selector);
    if (!root || !window.MutationObserver) return;
    var wasOpen = root.classList.contains('is-open');
    new MutationObserver(function () {
      var isOpen = root.classList.contains('is-open');
      if (isOpen && !wasOpen) {
        push('tos_popup_shown', {
          popup_type: type,
          popup_variant: root.getAttribute('data-variant') || ''
        });
      }
      wasOpen = isOpen;
    }).observe(root, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    watchQuizResult();
    watchPopup('.tos-timed[data-timed-popup]', 'timed');
    watchPopup('.tos-exit[data-exit-intent]', 'exit_intent');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
